import r2wc from "@r2wc/react-to-web-component";
import { ImagineWebComponentsWrapper as _ImagineWebComponentsWrapper } from "./components/views/imagine-web-components-wrapper";

export * from "./stores/imagine-config.store";
export * from "./wrapper/imagine-routing.store";

export const CUSTOM_ELEMENT_TAG = "imagine-web-components-wrapper" as const;

export type {
  InitImagineConfigConfig,
  InitImagineConfigOptions,
  InitImagineConfigFn,
} from "./stores/imagine-config.store";

const ImagineWebComponentsWrapper = r2wc(_ImagineWebComponentsWrapper, {
  shadow: "open",
});

if (!customElements.get(CUSTOM_ELEMENT_TAG)) {
  customElements.define(CUSTOM_ELEMENT_TAG, ImagineWebComponentsWrapper);
}
